import { type Hex } from "viem";

export const defaultAppName = 'ProveX'
export const defaultAppVersion = '1'
export const defaultChainId = 1

/**
 * The all-zero EVM address, inlined as a literal rather than imported from viem.
 *
 * This module is evaluated at import time (sacrifice-signers.ts instantiates its
 * signers via createSacrificeDomain() at module top level). Importing viem's
 * `zeroAddress` value here created a cross-chunk init-order hazard: Vite's
 * manualChunks places viem in `web3-vendor`, and the eip712 code could evaluate
 * before that chunk initialized, throwing "Cannot access 'zeroAddress' before
 * initialization" and blanking the whole app. The value is a fixed constant, so
 * inlining it removes the init-time dependency entirely. Equals viem's zeroAddress.
 */
const ZERO_ADDRESS: Hex = '0x0000000000000000000000000000000000000000'

/**
 * Creates a consistent EIP-712 domain for the sacrifice system
 * This ensures both frontend and backend use identical domain settings
 */
export function createSacrificeDomain(chainId: number = defaultChainId, verifyingContract: Hex = ZERO_ADDRESS) {
  return {
    name: defaultAppName,
    version: defaultAppVersion,
    chainId,
    verifyingContract,
  };
}
